/** The origin this app posts messages to. Passed in by the embedding host. */
export const TARGET_PARAM = 'target';

/** The `email` param, read on the two sent screens. */
export const EMAIL_PARAM = 'email';

/** Params this app owns, and the only ones it reports back to its host. */
export const PARAMS_TO_REPORT = ['code', EMAIL_PARAM] as const;
